import UriJs from 'urijs';

export function AdminAccessLevelPromptController(
    $stateParams,
    $window,
    PublicAuthenticationApi,
    BASE_PATH_PUBLIC
) {
    const vm = this;
    
    vm.visible = true;
    
    function initialize() {        
    }
    
    function redirectToLogin(returnUrl) {
        let loginUrl = new UriJs(`${BASE_PATH_PUBLIC}/authentication/login`);
        
        if (returnUrl) {
            // If there is a return URL we set it on the query string.
            loginUrl = loginUrl.query({returnUrl}); 
        }           

        $window.location.assign(loginUrl.href());
    }

    vm.onOverlayClick = function onOverlayClick() {
        // Do nothing here. We don't want users to be able to close the modal when clicking outside it.
    };

    vm.onCancelClick = function onCancelClick() {
        redirectToLogin();
    };

    vm.onCardClick = function onCardClick(accessLevel) {
        const request = {
            AccessLevel: accessLevel,
            Jwt: $stateParams.jwt
        };

        PublicAuthenticationApi.loginAdminUser(request)
            .then(response => {
                $window.location.assign(response.RedirectUrl);
            })
            .catch(error => {                
                if (error.status === 401) {
                    // Unauthorized
                    redirectToLogin(error.data.RedirectUrl);
                } else {
                    redirectToLogin();
                }
            });
    };
    
    initialize();
}

AdminAccessLevelPromptController.$inject = [
    '$stateParams', 
    '$window', 
    'PublicAuthenticationApi',
    'BASE_PATH_PUBLIC'
];
